module.exports = __webpack_public_path__ + "img/cta-sport-mob-fr.41b5cfc5.png";